import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Typography, Button, Grid, Select, MenuItem, InputLabel, FormControl } from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import { PageContainer } from '../../component/styled/PageContainer'
import { Export } from './Export'
import Populate from './Populate'

const getYearOptions = () => {
  // Set start year when CP58 form generation started
  const startYear = 2025
  // Get year based on current date
  const currentYear = new Date().getFullYear()

  const options = []

  // Insert year descending
  // -1 due to CP 58 form generated for previous year
  for (let year = currentYear - 1; year >= startYear; year--) {
    options.push({ value: year, label: year })
  }

  return options
}

export const CP58Screen = () => {
  const options = getYearOptions()
  const [open, setOpen] = useState(false)
  const [year, setYear] = useState(new Date().getFullYear() - 1) // -1 due to CP 58 form generated for previous year

  const handleOnChange = async (ev) => {
    setYear(ev.target.value)
  }

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>CP 58</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Grid container spacing={2} py={5} px={1}>
          <Grid item xs={12}>
            <Typography variant='h1'>CP 58</Typography>
          </Grid>
          <Grid item xs={12} display='flex' gap={2}>
            <FormControl fullWidth>
              <InputLabel id='filter-year-label'>Year</InputLabel>
              <Select
                id='filter-year'
                labelId='filter-year-label'
                value={year}
                label='Year'
                onChange={handleOnChange}
              >
                {options.map((e) => (
                  <MenuItem key={e.value} value={e.value}>
                    {e.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button
              variant='contained'
              color='primary'
              onClick={() => setOpen(true)}
              startIcon={<AddIcon style={{ color: '#FFFFFF' }} />}
              size='large'
            >
              Import
            </Button>
          </Grid>
          <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
            <Populate></Populate>
            <Export year={year}></Export>
          </Grid>
          <Grid item xs={12}>
            <Table year={year} open={open} setOpen={setOpen} />
          </Grid>
        </Grid>
      </PageContainer>
    </>
  )
}
